var styleDataHash = 'b0b1a564';  
export const injectCss = (() => {
  var css = `._3pRIH{height:17px;vertical-align:text-bottom}[dir] ._3pRIH{padding-top:2px}._3pRIH:hover{color:var(--ricos-settings-action-color,var(--ricos-action-color-fallback,#116dff))}._2j6Gb{display:flex}[dir] ._2j6Gb{cursor:pointer}`;
  var isTest = typeof process !== 'undefined' && process.env && process.env['NODE_ENV'] === 'test';

  if (isTest || !css || typeof document === 'undefined') { return; }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.setAttribute('data-ricos-style-hash', styleDataHash);
  style.type = 'text/css';

  head.appendChild(style);

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
});

injectCss();



export default {
  "infoIcon": "_3pRIH",
  "infoContainer": "_2j6Gb"
};